<template>
    <select :id="id" :disabled="disabled">
        <option class="select2-option-fixed" v-if="placeholder"></option>
        <slot></slot>
    </select>
</template>

<script>
export default {
    name: 'Select2',
    model: {
        event: 'change'
    },
    props: {
        id: String,
        options: Array,
        value: [String, Number],
        placeholder: String,
        idField: {type: String, default: 'id'},
        textField: {type: String, default: 'name'},
        selectedField: {type:String, default: 'default'},
        disabled: Boolean,
    },
    computed: {
        data() {
            return this.options.map(option => ({
                id: option[this.idField] ?? option[this.textField],
                text: option[this.textField] ?? option[this.idField],
                selected: option[this.selectedField] ?? undefined
            }));
        }
    },
    data() {
        return {
            select2: null,
        };
    },
    watch: {
        value(value) {
            this.value ? this.select2.val(value) : this.reset();
            this.select2.trigger('change');
        },
        data() {
            this.reset();
        }
    },
    methods: {
        mount() {
            $(this.$el).find('option').addClass('select2-option-fixed');

            this.select2 = $(this.$el).select2({
                data: this.data,
                placeholder: this.placeholder
            });

            this.select2.change(this.change);

            if (this.value) {
                this.select2.val(this.value).trigger('change');
            }
        },
        destroy() {
            this.select2.find('option').not('.select2-option-fixed').remove();
            this.select2.off().select2('destroy');
        },
        change() {
            this.$emit('change', this.find(this.$el.value));
        },
        reset() {
            this.destroy();
            this.mount();
        },
        find(value) {
            return this.data.filter(option => option.id == value)[0]?.id;
        }
    },
    mounted: function () {
        this.mount();
    },
    destroyed: function () {
        this.destroy();
    }
}
</script>
